export function createFundingAccountV2(send) {
  return (body, ...args) =>
    send(
      {
        path: '/v2/fundingAccounts',
        pathParameters: {},
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
